<template>
    <div>
        <video style="width:100%;" loop autoplay muted src="../../static/hero-animaatio.mp4" v-if="currentLocale=='fi'"></video>
        <img style="width:100%;" :src="'../../static/'+currentLocale+'/hero-etusivu.jpg'" alt="" v-else>

        <section v-for="(page, index) in pages" v-bind:key="index" :class="getSectionStyle(index)">
            <div class="container">
                <div class="row">
                    <div v-bind:class="['col-md-6', {'order-md-5' : index%2==0}]" v-if="index > 0">
                        <img class="c-hahmo" v-if="index===1" src="../assets/images/hahmo-immateriaalioikeudet.png" alt="">
                        <img class="c-hahmo" v-if="index===2" src="../assets/images/hahmo-mita-tekijanoikeus-tarkoittaa.png" alt="">
                        <img class="c-hahmo" v-if="index===3" src="../assets/images/hahmo-tekijanoikeuden-luovuttaminen.png" alt="">
                        <img class="c-hahmo" v-if="index===4" src="../assets/images/hahmo-teosten-kaytto.png" alt="">
                        <img class="c-hahmo" v-if="index===5" src="../assets/images/hahmo-omantuottamisen-prosessi.png" alt="">
                    </div>
                    <div v-bind:class="['col-md-6', {'offset-md-3 text-center' : index == 0}]">
                        <h1 v-if="index === 0" class="text-uppercase">{{page.title.rendered}}</h1>
                        <h2 v-if="index > 0">{{page.title.rendered}}</h2>
                        <div v-html="page.content.rendered"></div>
                        <router-link v-if="index===1" class="button btn-white" :to="{path: '/' + currentLocale + '/los-derechos-de-propiedad-intelectual'}">{{ $t('general.siirry', currentLocale) }}</router-link>
                        <router-link v-if="index===2" class="button btn-white" :to="{path: '/' + currentLocale + '/que-significan-los-derechos-de-autor'}">{{ $t('general.siirry', currentLocale) }}</router-link>
                        <router-link v-if="index===3" class="button btn-white" :to="{path: '/' + currentLocale + '/la-cesion-de-los-derechos-de-autor'}">{{ $t('general.siirry', currentLocale) }}</router-link>
                        <router-link v-if="index===4" class="button btn-white" :to="{path: '/' + currentLocale + '/uso-de-las-obras'}">{{ $t('general.siirry', currentLocale) }}</router-link>
                        <router-link v-if="index===5" class="button btn-white" :to="{path: '/' + currentLocale + '/produccion-personal'}">{{ $t('general.siirry', currentLocale) }}</router-link>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="container">
                <div class="row py-5">
                    <div class="col-md-6 offset-md-3 text-center form-group" v-if="!pagesLoading">
                        <h1>{{ $t('general.jatka', currentLocale) }}</h1>
                        <button class="button mt-3" v-on:click="showLogin" style="background-color: #059DF3">{{ $t('navbar.kirjaudu', currentLocale) }}</button>
                    </div>
                    <div class="col-md-6 offset-md-3 text-center" v-else>
                        <h1>{{ $t('general.ladataan', currentLocale) }}</h1>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
  import secretStore from '../utils/localstorage'

  export default {
    data: function () {
      return {
        pagesLoading: false,
        pages: [],
        secretStore
      }
    },
    created: function () {
      this.fetchPages()
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
    methods: {
      fetchPages: function () {
        this.pagesLoading = true
        this.axios.get('pages/?parent=0&lang='+this.currentLocale+'&orderby=menu_order&order=asc').then((response) => {
          this.pages = response.data
          this.currentPage = 0
          this.pagesLoading = false
        })
      },
      getSectionStyle: function (index) {
        var style = ''
        var colors = ['bg-white','bg-red', 'bg-blue', 'bg-yellow', 'bg-green', 'bg-purple']
        style = colors[index] + ' cta'
        if (index % 2 == 0) {
          style += ' image-right'
        }
        return style
      },
      showLogin: function () {
        this.$parent.$emit('showLogin')
      }
    }
  }

</script>
<style scoped lang="scss">
    .cta {
        img {
            height: auto;
            max-height:300px;
            max-width:100%;
        }
    }
    @media(max-width:767.98px) {
        .c-hahmo {
            margin-bottom:2rem;
        }
        .image-right {
            img {
                float:initial;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Korkeakoulu.vue